import { call, put, takeLatest } from 'redux-saga/effects';
import makeSagaRequest from 'app/shared/sagas/makeSagaRequest';

// Models
import { AlertsActionTypes } from 'app/modules/alerts/models';

// Actions
import {
  retrieveAlertEntities as retrieveAlertEntitiesAction,
  retrieveAlertEntitiesSuccess,
} from 'app/modules/alerts/actions';

// API
import { retrieveAlertEntities as retrieveAPI } from 'app/shared/api/alerts';

const rootAction = AlertsActionTypes.RETRIEVE_ALERT_ENTITIES;
export function* retrieveAlertEntities({
  payload,
}: ReturnType<typeof retrieveAlertEntitiesAction>) {
  const config = {
    rootAction,
    request: call(retrieveAPI, payload.alertId, payload),
    success: function* onSuccess(result) {
      yield put(retrieveAlertEntitiesSuccess(result));
    },
  };

  yield call(makeSagaRequest, config);
}

export default function* watchRetrieveAlertEntities() {
  yield takeLatest(rootAction, retrieveAlertEntities);
}
